import {contains, containsIgnoreCase} from "../Utils/ArrayUtils";

const bossTrophies = [
    "Judicator's Mask", "Abhorrent Heart",
    "Exquisite Blood",
    "Malignant Heart", "Living Steel", "Distilled Fear", "Shard of Agony", "Pincushioned Doll",
]

const lairBossKeys = [
    "Betrayer's Husk", "Greater Lair Key", "Lair Key", "Crux Of The False Prophet"
    ];

const lairBossKeyDescriptions = {
    "Crux Of The False Prophet": ["Used to open Mephisto's Hoard"],
    "Betrayer's Husk": ["Used to open Belial's Hoard, requires 2"],
    "Lair Key": ["Used to open a Lair Boss Hoard"],
    "Greater Lair Key": ["Used to open a Greater Lair Boss Hoard"]
}

const uniqueInvocationRunes= [
    "Ber", "Ist", "Ith", "Lo", "Ral", "Tir", "Sol"
]
const uniqueRitualRunes= [
    "Amn", "Eth", "Mal", "Ort", "Tal"
]
const legInvocationRunes= [
    "Eom", "Jah", "Ohm", "Vex", "Yom"
]
const legRitualRunes= [
    "Bac", "Igni", "Tam", "Yul"
]
const magicInvocationRunes = [
    "Ceh", "Gar", "Kry", "Ner", "Prid", "Qua", "Teb", "Tzic"
]
const magicRitualRunes = [
    "Cem", "Cir", "Moni", "Yax"
]
const rareInvocationRunes = [
    "Kel", "Lac", "Mot", "Que", "Thul", "Wat"
]
const rareRitualRunes = [
    "Nagu", "Neo", "Noc", "Poc", "Zan"
]




export const anyMagicRune = "Any Magic Rune";
const magicRunes = [anyMagicRune].concat(magicInvocationRunes).concat(magicRitualRunes);
export const anyRareRune = "Any Rare Rune";
const rareRunes = [anyRareRune].concat(rareInvocationRunes).concat(rareRitualRunes);
export const anyLegendaryRune = "Any Legendary Rune";
const legendaryRunes = [anyLegendaryRune].concat(legInvocationRunes).concat(legRitualRunes);
export const anyUniqueRune = "Any Unique Rune";
const uniqueRunes = [anyUniqueRune].concat(uniqueInvocationRunes).concat(uniqueRitualRunes);

const invocationRunes = uniqueInvocationRunes.concat(legInvocationRunes.concat(magicInvocationRunes).concat(rareInvocationRunes));
const ritualRunes = uniqueRitualRunes.concat(legRitualRunes.concat(magicRitualRunes).concat(rareRitualRunes));

const runes = invocationRunes.concat(ritualRunes).sort();

const runeSets = [
    "Andariel's Visage",
    "Doombringer",
    "Harlequin Crest",
    "Heir of Perdition",
    "Melted Heart of Selig",
    "Ring of Starless Skies",
    "Shattered Vow",
    "Shroud of False Death",
    "The Grandfather",
    "Tyrael's Might",
].sort();

const runeSetDescriptions = {
    "Andariel's Visage": ["Tam (6)", "Zan (6)", "Cir (6)"],
    "Doombringer": ["Yul (6)", "Noc (6)", "Qua (6)"],
    "Harlequin Crest": ["Eom (6)", "Lac (6)", "Ceh (6)"],
    "Heir of Perdition": ["Jah (6)", "Que (6)", "Gar (6)"],
    "Melted Heart of Selig": ["Vex (6)", "Thul (6)", "Kry (6)"],
    "Ring of Starless Skies": ["Ohm (6)", "Wat (6)", "Cem (6)"],
    "Shattered Vow": ["Igni (6)", "Kel (6)", "Teb (6)"],
    "Shroud of False Death": ["Bac (6)", "Noc (6)", "Moni (6)"],
    "The Grandfather": ["Tam (6)", "Mot (6)", "Yax (6)"],
    "Tyrael's Might": ["Yom (6)", "Nagu (6)", "Tzic (6)"]
}

const gems = [
    "Any Horadric Gem",
    "Any Grand Gem",
    "Any Royal Gem",
    "Flawless Horadric Diamond",
    "Flawless Horadric Emerald",
    "Flawless Horadric Ruby",
    "Flawless Horadric Skull",
    "Flawless Horadric Topas",
    "Flawless Horadric Amethyst",
    "Flawless Horadric Sapphire",
    "Horadric Diamond",
    "Horadric Emerald",
    "Horadric Ruby",
    "Horadric Skull",
    "Horadric Topas",
    "Horadric Amethyst",
    "Horadric Sapphire",
    "Grand Diamond",
    "Grand Emerald",
    "Grand Ruby",
    "Grand Skull",
    "Grand Topas",
    "Grand Amethyst",
    "Grand Sapphire",
    "Royal Diamond",
    "Royal Emerald",
    "Royal Ruby",
    "Royal Skull",
    "Royal Topas",
    "Royal Amethyst",
    "Royal Sapphire"
];

export const normalRarity = "Normal";
export const magicRarity = "Magic";
export const rareRarity = "Rare";
export const legendaryRarity = "Legendary";
export const uniqueRarity = "Unique";
export const mythicRarity = "Mythic";
export const setRarity = "Set";
export const ITEM_RARITIES = ["Any", uniqueRarity, legendaryRarity, rareRarity, magicRarity, normalRarity, setRarity, mythicRarity];
export const DEFAULT_ITEM_RARITY = ITEM_RARITIES[2];

export const consumablesRarities = {
    "Aggressive Tuning Prism": magicRarity,
    "Pragmatic Tuning Prism": magicRarity,
    "Protector's Tuning Prism": magicRarity,
    "Resourceful Tuning Prism": magicRarity,

    "Adept's Tuning Prism": rareRarity,
    "Chromatic Tuning Prism": rareRarity,

    "Entropic Tuning Prism": legendaryRarity,

    "Kullean Tuning Prism": uniqueRarity
}

export const bossTrophy = "Boss Trophy";
export const lairBossKey = "Lair Boss Key";
export const rune="Rune";
export const runeSet = "Rune Set";
export const gem = "Gem";
export const consumable = "Consumable";

export const getLairBossKeyDescription = function (lairBossKey) {
    const descriptions = lairBossKeyDescriptions[lairBossKey]
    if (descriptions) {
        return descriptions;
    } else {
        return [];
    }
}

export const getRuneSetDescription = function (runeSet) {
    const descriptions = runeSetDescriptions[runeSet]
    if (descriptions) {
        return descriptions;
    } else {
        return [];
    }
}

export const PLATFORMS = ["ALL"];
export const REGIONS = ["EUROPE"];
export const MODES = ["SOFTCORE", "HARDCORE"];
export const REALM = ["SEASON", "ETERNAL"];

export const CURRENCY_TYPES = ["Gold", rune, lairBossKey, gem, consumable]
export const CURRENCY_NAMES = {
    "Gold": ["Million Gold"],
    "Lair Boss Key": lairBossKeys,
    "Boss Trophy": bossTrophies,
    "Rune": [anyMagicRune, anyRareRune, anyLegendaryRune, anyUniqueRune].concat(runes),
    "Rune Set": runeSets,
    "Gem": gems,
    "Consumable": Object.keys(consumablesRarities)
}

//do not change the order since the indexes get used by this fixed order
export const CLASSES = ["Any", "Druid", "Rogue", "Necromancer", "Barbarian", "Sorcerer", "Spiritborn", "Paladin", "Warlock"];

export const ITEM_TYPES = ["Any", "Weapon", "Armor", "Jewelry", "Talisman", "Misc"];

export const ITEM_TYPES_WITH_RARITY = ["Any", "Weapon", "Armor", "Jewelry", "Talisman"]
export const ITEM_TYPES_WITH_DPS = ["Weapon"]
export const ITEM_TYPES_WITH_ARMOR = ["Armor"]
export const ITEM_TYPES_WITH_ALL_RESIST = ["Jewelry"]

export const canHaveAspects = function (baseItem) {
    return baseItem !== undefined && baseItem != null && (baseItem.rarity === ITEM_RARITIES[0] || baseItem.rarity === ITEM_RARITIES[2]);
}

export const canHaveUniqueAffix = function (baseItem) {
    return baseItem !== undefined && baseItem != null && (baseItem.rarity === ITEM_RARITIES[0] || baseItem.rarity === ITEM_RARITIES[1]);
}

export const canHaveMythicAffix = function (baseItem) {
    return baseItem !== undefined && baseItem != null && (baseItem.rarity === ITEM_RARITIES[0] || baseItem.rarity === ITEM_RARITIES[7]);
}

export const canHaveSetAffix = function (baseItem) {
    return baseItem !== undefined && baseItem != null && (baseItem.rarity === ITEM_RARITIES[0] || baseItem.rarity === ITEM_RARITIES[6]);
}

export const isLegendaryOrUnique = function (baseItem) {
    return baseItem !== undefined && baseItem != null && (baseItem.rarity === ITEM_RARITIES[1] || baseItem.rarity === ITEM_RARITIES[2]);
}

export const canHaveDps = function (baseItem, baseStats) {
    if (baseStats && baseStats.dps > 0) {
        return true;
    }

    return contains(ITEM_TYPES_WITH_DPS, baseItem.itemType) && baseItem.name !== "Shield";
}

export const canHaveArmor = function (baseItem, baseStats) {
    if (baseStats && baseStats.armor > 0) {
        return true;
    }

    return contains(ITEM_TYPES_WITH_ARMOR, baseItem.itemType) || baseItem.name === "Shield";
}

export const canHaveAllResist = function (baseItem, baseStats) {
    if (baseStats && baseStats.allResist > 0) {
        return true;
    }

    return contains(ITEM_TYPES_WITH_ALL_RESIST, baseItem.itemType);
}

export const ITEM_SUB_TYPES = {
    "Any": ["Any"],
    "Weapon": ["Two-Handed", "One-Handed", "Off-Hand", "Bow", "Crossbow"],
    "Armor": ["Helm", "Chest", "Gloves", "Pants", "Boots"],
    "Jewelry": ["Amulet", "Ring"],

    "Talisman": ["Charm", "Horadric Seal"],
    "Misc": [bossTrophy, lairBossKey, gem, rune, runeSet, consumable]
}

//nur Ausrüstung kann Aspects haben
export const itemsWithoutAspects = ITEM_SUB_TYPES["Talisman"].concat(ITEM_SUB_TYPES["Misc"]);
//es gibt legendäre nicht Ausrüstung (wie z.B. Charms), die aber keine Aspects benötigen
export const isItemWithNeededAspectAsLegendary = function (itemName) {
    return !contains(itemsWithoutAspects, itemName);
}

export const isLairBossKey = function (item) {
    return item && item.subType === lairBossKey;
}

export const isBossTrophy = function (item) {
    return item && item.subType === bossTrophy;
}

export const isMagicRune = function (item) {
    return item && contains(magicRunes, item.name);
}

export const isRareRune = function (item) {
    return item && contains(rareRunes, item.name);
}

export const isLegendaryRune = function (item) {
    return item && contains(legendaryRunes, item.name);
}

export const isUniqueRune = function (item) {
    return item && contains(uniqueRunes, item.name);
}

export const isRitualRune = function (item) {
    return item && contains(ritualRunes, item.name);
}

export const isInvocationRune = function (item) {
    return item && contains(invocationRunes, item.name);
}

export const isRune = function (item) {
    return item && item.subType === rune;
}

export const isGem = function (item) {
    return item && item.subType === gem;
}

export const isConsumable = function (item) {
    return item && item.subType === consumable;
}

export const isRuneSet = function (item) {
    return item && item.subType === runeSet;
}

export const isRuneOrRuneSet = function (item) {
    return item && (item.subType === runeSet || item.subType === rune);
}

export const ITEM_SUB_TYPES_WITH_AMOUNT = ITEM_SUB_TYPES["Misc"]
export const ITEM_SUB_TYPES_WITHOUT_STATS = ITEM_SUB_TYPES["Misc"]

export const ITEM_NAMES = {
    "Leveling": ["Any", "1-50", "1-30", "30-50", "50-60", "60-70", "70-80"],
    "World Tier Unlock": ["Any", "T3", "T4", "T3+T4"],
    "Boss Kill": ["Any", "Uber Lilith", "Uber Malphas", "Duriel (seller mats)", "Duriel (buyer mats)", "Varshan (seller mats)", "Varshan"
    + " (buyer mats)", "Grigoire (seller mats)", "Grigoire (buyer mats)"],
    "Any": ["Any"],
    "Two-Handed": ["Any", "Axe", "Mace", "Polearm", "Staff", "Sword", "Scythe", "Quarterstaff"], //Reihenfolge nicht ändern, da in D4ItemCard.js verwendet
    "One-Handed": ["Any", "Axe", "Mace", "Staff", "Sword", "Scythe", "Dagger", "Wand", "Flail"], //Reihenfolge nicht ändern, da in D4ItemCard.js verwendet
    "Bow": ["Any", "Bow"],
    "Crossbow": ["Any", "Crossbow"],
    "Off-Hand": ["Any", "Book", "Focus", "Shield", "Totem"],

    "Helm": ["Any", "Helm"],
    "Chest": ["Any", "Chest"],
    "Gloves": ["Any", "Gloves"],
    "Pants": ["Any", "Pants"],
    "Boots": ["Any", "Boots"],

    "Amulet": ["Any", "Amulet"],
    "Ring": ["Any", "Ring"],

    "Charm": ["Any", "Charm"],
    "Horadric Seal": ["Any", "Horadric Seal"],

    "Boss Trophy": ["Any"].concat(bossTrophies),
    "Lair Boss Key": ["Any"].concat(lairBossKeys),
    "Rune": ["Any"].concat([anyMagicRune, anyRareRune, anyLegendaryRune, anyUniqueRune].concat(runes)),
    "Rune Set": ["Any"].concat(runeSets),
    "Gem": ["Any"].concat(gems),
    "Consumable": ["Any"].concat(Object.keys(consumablesRarities))
}

export const getCurrencyTypeByCurrency = function (currency) {
    let result;
    Object.keys(CURRENCY_NAMES).forEach(key => {
        if (containsIgnoreCase(CURRENCY_NAMES[key], currency)) {
            result = key;
        }
    });
    return result;
}

export const getItemTypesByName = function (name) {
    let subTypes = [];
    Object.keys(ITEM_NAMES).forEach(key => {
        if (containsIgnoreCase(ITEM_NAMES[key], name)) {
            subTypes.push(key)
        }
    });

    let result = [];

    subTypes.forEach(subType => {
        Object.keys(ITEM_SUB_TYPES).forEach(key => {
            if (containsIgnoreCase(ITEM_SUB_TYPES[key], subType)) {
                result.push({
                    itemType: key,
                    itemSubType: subType
                })
            }
        })
    })

    return result;
}